export const selectCaptchaImage = (state) => state.captchaStore.image;
export const selectCaptchaText = (state) => state.captchaStore.text;
export const selectCaptchaStatus = (state) => state.captchaStore.status;
export const selectCaptchaError = (state) => state.captchaStore.error;
export const selectCaptchaPassed = (state) => state.captchaStore.isPassed;